import { render, staticRenderFns } from "./QPieChartCarrierPlaced2.vue?vue&type=template&id=c72cdc26&scoped=true&"
import script from "./QPieChartCarrierPlaced2.vue?vue&type=script&lang=js&"
export * from "./QPieChartCarrierPlaced2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72cdc26",
  null
  
)

export default component.exports